import _ from 'lodash';
import { useEffect } from 'react';
import { ADMIN_CONTACT_PARTNER } from '../../constants/admin.contacts.constants';
import { ALL_SELECT_OPTION } from '../../constants/settings.constants';
import { useDependency } from '../../hooks/useDependency.hook';
import adminSchoolsService from '../../services/api/admin.schools.service';
import partnersService from '../../services/api/partners.service';
import ContactOrganizationModal from './ContactOrganizationModal';

const ContactOrganizationModalContainer = ({
  addModal,
  updateModal,
  onAdd,
  onUpdate,
  onDelete,
  onInput,
  type,
  data
}) => {
  const schoolNets = useDependency(adminSchoolsService.getSchoolNetsOptions);
  const organizations = useDependency(partnersService.getPartnersOptions);
  const schoolManagements = useDependency(adminSchoolsService.getAllManagements, {
    mapResponse: (items) => items?.map((i) => ({ ...i, value: i.id, label: i.name }))
  });
  const schoolCommunities = useDependency(adminSchoolsService.getAllCommunities, {
    mapResponse: (items) => items?.map((i) => ({ ...i, value: i.id, label: i.name }))
  });
  const schools = useDependency(adminSchoolsService.getAllSchools, {
    mapResponse: (items) => items?.map((i) => ({ ...i, value: i.id, label: i.name }))
  });
  const branches = {
    isLoading: schools.isLoading,
    loadError: schools.loadError,
    options: _.flatten(
      schools.options?.map(
        (s) =>
          s?.branches?.map((b) => ({ ...b, value: b.id, label: b.name, schoolId: s.id, communityId: s.communityId })) ??
          []
      )
    )
  };

  const handleInput = (value, field) => {
    if (field === 'organization') {
      onInput(organizations.options?.find((o) => o.value === value)?.label ?? '', 'organizationName');
    }

    if (field === 'net') {
      onInput(
        value === ALL_SELECT_OPTION.value
          ? ALL_SELECT_OPTION.label
          : schoolNets.options?.find((o) => o.value === value)?.label ?? '',
        'netName'
      );
    }
    if (field === 'management') {
      onInput(
        value === ALL_SELECT_OPTION.value
          ? ALL_SELECT_OPTION.label
          : schoolManagements.options?.find((o) => o.value === value)?.label ?? '',
        'managementName'
      );
    }
    if (field === 'community') {
      onInput(
        value === ALL_SELECT_OPTION.value
          ? ALL_SELECT_OPTION.label
          : schoolCommunities.options?.find((o) => o.value === value)?.label ?? '',
        'communityName'
      );
    }
    if (field === 'school') {
      onInput(
        value === ALL_SELECT_OPTION.value
          ? ALL_SELECT_OPTION.label
          : schools.options?.find((o) => o.value === value)?.label ?? '',
        'schoolName'
      );
    }
    if (field === 'branch') {
      onInput(
        value === ALL_SELECT_OPTION.value
          ? ALL_SELECT_OPTION.label
          : branches.options?.find((o) => o.value === value)?.label ?? '',
        'branchName'
      );
    }

    const fieldsThatShouldUnapproveOnChange = ['branch', 'school', 'community', 'management', 'net'];
    if (updateModal.isOpen && fieldsThatShouldUnapproveOnChange.includes(field)) {
      onInput(false, 'isApproved');
    }

    onInput(value, field);
  };

  useEffect(() => {
    schoolNets.onLoad();
  }, [schoolNets]);

  useEffect(() => {
    if (data?.net) {
      schoolManagements.onLoad();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.net]);

  useEffect(() => {
    if (data?.net && data?.management) {
      schoolCommunities.onLoad();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.management, data?.net]);

  useEffect(() => {
    if (data?.net && data?.management && data?.community) {
      schools.onLoad();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.community, data?.management, data?.net]);

  useEffect(() => {
    if (type === ADMIN_CONTACT_PARTNER) {
      organizations.onLoad();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  if (addModal.isOpen) {
    return (
      <ContactOrganizationModal
        {...addModal}
        data={data}
        type={type}
        organizationsDependency={organizations}
        netsDependency={schoolNets}
        managementsDependency={schoolManagements}
        communitiesDependency={schoolCommunities}
        schoolsDependency={schools}
        branchesDependency={branches}
        onInput={handleInput}
        onConfirm={onAdd}
      />
    );
  }

  if (updateModal.isOpen) {
    return (
      <ContactOrganizationModal
        {...updateModal}
        isEdit
        data={data}
        type={type}
        organizationsDependency={organizations}
        netsDependency={schoolNets}
        managementsDependency={schoolManagements}
        communitiesDependency={schoolCommunities}
        schoolsDependency={schools}
        branchesDependency={branches}
        onInput={handleInput}
        onConfirm={onUpdate}
        onDelete={onDelete}
      />
    );
  }

  return null;
};

export default ContactOrganizationModalContainer;
